import { render, staticRenderFns } from "./k2Editor.vue?vue&type=template&id=45534568"
import script from "./k2Editor.vue?vue&type=script&lang=js"
export * from "./k2Editor.vue?vue&type=script&lang=js"
import style0 from "./k2Editor.vue?vue&type=style&index=0&id=45534568&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports